export class ActivateSuspendDto {
  workItemID: any[] = [];
  queueId: number = 0;
  workflowID: number = 0;
  wiStatusName: string = '';
  userGPID: string = '';
  systemID: number = 0;
}
